import { gateway } from "../../../gateway";

export const deletePasswordVaultAction = async (id: string) => {
  const token = sessionStorage.getItem("token");

  const res = await gateway.delete(`passwords/${id}`, {
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });

  return res.data;
};
